import { useAppSelector } from 'appState/store'
import { CallNotesForm } from 'features/calls/components'
import { IClaim } from 'features/claims/types/claimsTypes'
import { isCurrentUserClaimOwner } from 'features/claims/utils'
import { Card } from '@outbound-ai/ursa'

interface IProps {
  callId: string
  claim: IClaim
}
export const PostCallNotes = ({ callId, claim }: IProps) => {
  const { user } = useAppSelector((state) => state.auth)
  const isOwner = isCurrentUserClaimOwner(claim?.ownerId, user!)

  return (
    <Card title="Call Notes" className="cards">
      <CallNotesForm callId={callId} disabled={!isOwner} />
    </Card>
  )
}
